import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

import { ReportsService } from '../../../../core/services/reports.service';
import { LoadingService } from '../../../../core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class GroupSummaryResolver  {
  constructor(
    private reportsService: ReportsService,
    private loadingService: LoadingService,
  ) {}

  resolve(): Observable<any> {
    this.loadingService.start() ;
    return this.reportsService.getGroupSummaryReportData().pipe(
      map((data) => {
        this.loadingService.finish() ;

        return data ;
      }),
      catchError((error) => {
        this.loadingService.finish() ;

        return of(error.status) ;
      })
    ) ;
  }
}
